import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudCalendarModule,
	FreudInputNumberModule,
	FreudInputTextAreaModule,
	FreudRadioButtonModule,
	FreudSelectButtonModule,
	FreudSelectModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { ContactSelectModule } from 'modules/contacts/components/contact-select/contact-select.module';
import { NgxUnleashProxyClientModule } from 'shared/unleash/ngx-unleash-proxy-client.module';

import { ModalSidebarModule } from '../../../../shared/components/modal-sidebar/modal-sidebar.module';
import { AppointmentDateTimeModule } from '../appointment-date-time/appointment-date-time.module';
import { AppointmentExpirationSelectModule } from '../appointment-expiration-select/appointment-expiration-select.module';
import { AppointmentRecurrrencyModule } from '../appointment-recurrency/appointment-recurrency.module';
import { AppointmentsNoShowSelectModule } from '../appointments-no-show-select/appointments-no-show-select.module';
import { FrequencySelectModule } from '../frequency-select/frequency-select.module';
import { AppointmentFormComponent } from './appointment-form.component';

@NgModule({
	declarations: [AppointmentFormComponent],
	imports: [
		CommonModule,
		ModalSidebarModule,
		TranslateModule.forChild(),
		FreudSelectButtonModule,
		FreudInputNumberModule,
		FreudButtonModule,
		ContactSelectModule,
		FreudInputTextAreaModule,
		FreudSelectModule,
		ReactiveFormsModule,
		FreudCalendarModule,
		FreudRadioButtonModule,
		FreudTypographyModule,
		FrequencySelectModule,
		AppointmentsNoShowSelectModule,
		AppointmentRecurrrencyModule,
		NgxUnleashProxyClientModule,
		AppointmentExpirationSelectModule,
		AppointmentDateTimeModule,
	],
	exports: [AppointmentFormComponent],
})
export class AppointmentFormModule {}
